const Vue = require('vue')
const $ = require('jquery')
const { guid } = require('sci/helpers')

Vue.directive('nice-scroll', {
    params: ['scroll-on-click'],
    bind () {
        const $target = $(this.el)
        const id = guid()

        $target.attr('id', id)

        const $holder = $('body')

        $holder.scrollspy({ target: $target, 'offset': 150 })

        const $links = $target.find('a[href^="#"],a[data-target]')

        if (this.params.scrollOnClick) {
            $target.on('click', 'a[href^="#"],a[data-target]', function () {
                const el = $(this)
                const href = el.attr('href')

                try {
                    const $box = $(href)
                    if ($box.length) {
                        $(window).animate({
                            scrollTop: $box.offset().top - 75
                        }, 500, function () {
                            window.history.pushState(null, el.text(), href)
                        })
                    } else {
                        $(this).blur()
                    }
                } catch (err) {
                }
                return false
            })
        }

        $holder.scrollspy('refresh')
        $holder.scroll()

        $links.first().closest('li').addClass('active')

        $(window).on('scroll.bs.scrollspy', function () {
            if ($target.find('li.active').length < 1) {
                $links.first().closest('li').addClass('active')
            }
        })
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/nice-scroll.js